import styled from '@xstyled/styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 100px 10px 100px 10px;
  display: grid;
  gap: 10px;
  position: relative;

  a {
    color: accentDark;
  }

  [data-dnd-placeholder] {
    background: none !important;
  }

  /* Broader override for any overlay elements */
  div[class*='DraggableComponent-overlay'] {
    outline: none !important;
    background: transparent !important;
    border: none !important;
  }

  @media only screen and (min-width: sm) and (max-width: 1024px) and (orientation: portrait) {
    .left_CardInHalfPage {
      background-color: unset;
    }
  }
  @media (max-width: sm) {
    grid-template-rows: unset;
    .bgImage {
    }
    .emptyBgImage {
      display: none;
    }
  }
`;
